<!-- eslint-disable vue/no-deprecated-v-bind-sync -->
<template>
  <v-row class="mb-2">
    <v-col cols="4">
      <FacetValuesSelection
        v-model="facetNewValue.valueFROM"
        :type="typeOfInput"
        :facet="facetNewValue.facet"
        :disabled="!facetNewValue.facet"
        :multiple="false"
        :free-field="true"
        :rules="[(v) => !!v || 'Required', invalidValues]"
      />
    </v-col>

    <v-col class="d-flex justify-space-around align-center" cols="2">
      <p>Et</p>
    </v-col>

    <v-col cols="4">
      <FacetValuesSelection
        v-model="facetNewValue.valueTO"
        :type="typeOfInput"
        :facet="facetNewValue.facet"
        :disabled="!facetNewValue.facet"
        :multiple="false"
        :free-field="true"
        :rules="[(v) => !!v || 'Required']"
      />
    </v-col>
  </v-row>
</template>

<script setup>

import { ref, computed, onMounted } from 'vue';
import { useStore } from 'vue2-helpers/vuex';

import FacetValuesSelection from './FacetValuesSelection.vue';

const { useFacetSettings } = require('@/utils/merch');

const props = defineProps({ filtersValues: { type: Object, required: true } });

const facetNewValue = ref(props.filtersValues);
const store = useStore();
const { disableCopyPaste, searchByQuery, facetsList, facetSettings } = useFacetSettings(facetNewValue, store.getters.ruleFacets);

const invalidValuesLabel = computed(() => `${facetNewValue.value.valueFROM.label} is bigger than ${facetNewValue.value.valueTO.label}`);

const invalidValues = computed(() => {
  if (facetNewValue.value.valueFROM && facetNewValue.value.valueTO) {
    if (parseFloat(facetNewValue.value.valueFROM.value) > parseFloat(facetNewValue.value.valueTO.value)) {
      return invalidValuesLabel.value;
    }
  }

  return true;
});

const isDate = computed(() => facetSettings.value.config.formatLabel === 'date');

const typeOfInput = computed(() => (isDate.value ? 'text' : 'number'));

</script>
